import Vue from "vue"
import Router from "vue-router"
Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  mode: "history",
  // mode: 'hash',
  base: "/community/",
  routes: [
    //默认跳转路由
    {
      path: "/",
      redirect: "/login",
    },
    //默认跳转路由
    {
      path: "/community.html",
      redirect: "/login",
    },
    {
      path: "/login",
      component: () => import("../page/login.vue"),
    },
    {
      path: "/upload_bd",
      component: () => import("../page/upload_bd.vue"),
    },
    {
      path: "/upload_custom_position",
      component: () => import("../page/upload_custom_position.vue"),
    },
    {
      path: "/upload_bond",
      component: () => import("../page/upload_bond.vue"),
    },
    {
      path: "/follow",
      component: () => import("../page/follow.vue"),
    },
    {
      path: "/discover",
      component: () => import("../page/discover.vue"),
    },
    {
      path: "/work",
      component: () => import("../page/work.vue"),
    },
    {
      path: "/publish",
      name: "Publish",
      component: () => import("../page/publish.vue"),
    },
    {
      path: "/ranking",
      name: "Ranking",
      component: () => import("../page/ranking.vue"),
    },
  ],
})



//////////////////
// WEBPACK FOOTER
// ./entries/community/router/index.js
// module id = ai/H
// module chunks = 4 7 10 30